/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import PropTypes from 'prop-types';
import React from 'react';
import styles from 'components/TextInput/TextInput.scss';

const TextInput = (props) => {
  const changeValue = (e) => {
    props.onChange(e.nativeEvent.target.value);
  }

  let classes = [styles.text_input];

  if (props.theme == 'dark') {
    classes.push(styles.dark);
  }

  if (props.theme == 'migration') {
    classes.push(styles.migration);
  }

  if (props.monospace) {
    classes.push(styles.monospace);
  }

  if (props.multiline) {
    return (
      <textarea
        disabled={!!props.disabled}
        className={classes.join(' ')}
        maxLength={props.maxlength}
        rows={props.rows}
        style={{ height: props.rows ? "auto" : props.height, width: props.width }}
        placeholder={props.placeholder}
        value={props.value}
        onChange={changeValue} />
    );
  }

  return (
    <input
      type={props.hidden ? 'password' : 'text'}
      disabled={!!props.disabled}
      className={classes.join(' ')}
      style={{ width: props.width }}
      maxLength={props.maxlength}
      placeholder={props.placeholder}
      autoComplete='off'
      value={props.value}
      onChange={changeValue}
      onBlur={props.onBlur} />
  );
}

export default TextInput;

TextInput.propTypes = {
  monospace: PropTypes.bool,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  multiline: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  maxlength: PropTypes.string,
  theme: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
